export const NotificationPreferenceType = Object.freeze({
	COMMUNICATION_BOOKINGS: {
		id: 'communicationBookings',
		name: 'COMMUNICATION_BOOKINGS',
		backendId: 'customers_notifications_bookings',
		notificationType: 'push_notification'
	},
	COMMERCIAL_POOTSY_EMAIL: {
		id: 'commercialPootsyEmail',
		name: 'COMMERCIAL_POOTSY_EMAIL',
		backendId: 'customers_commercial_notification_from_pootsy',
		notificationType: 'email'
	},
	COMMERCIAL_POOTSY_PUSH: {
		id: 'commercialPootsyPush',
		name: 'COMMERCIAL_POOTSY_PUSH',
		backendId: 'customers_commercial_notification_from_pootsy',
		notificationType: 'push_notification'
	},
	COMMERCIAL_AFFILIATE: {
		id: 'commercialAffiliate',
		name: 'COMMERCIAL_AFFILIATE',
		backendId: 'customers_commercial_notification_from_affiliate',
		notificationType: 'email'
	},
	COMMUNICATION_EMAIL: {
		id: 'communicationEmail',
		name: 'COMMUNICATION_EMAIL',
		backendId: 'customers_notifications_communication',
		notificationType: 'email'
	},
	COMMUNICATION_PUSH: {
		id: 'communicationPush',
		name: 'COMMUNICATION_PUSH',
		backendId: 'customers_notifications_communication',
		notificationType: 'push_notification'
	}
})

export const findNotificationPreferenceType = (backendId, notificationType) => {
	let notificationPreferenceTypes = Object.keys(NotificationPreferenceType)
	for (let i = 0; i < notificationPreferenceTypes.length; i++) {
		let notificationPreferenceType = NotificationPreferenceType[notificationPreferenceTypes[i]]
		if (notificationPreferenceType.backendId === backendId && notificationPreferenceType.notificationType === notificationType) {
			return notificationPreferenceType.name
		}
	}

	return null
}

export const findNotificationPreferenceTypeById = (id) => {
	let notificationPreferenceTypes = Object.keys(NotificationPreferenceType)
	for (let i = 0; i < notificationPreferenceTypes.length; i++) {
		let notificationPreferenceType = NotificationPreferenceType[notificationPreferenceTypes[i]]
		if (notificationPreferenceType.id === id) {
			return notificationPreferenceType
		}
	}

	return null
}


// WEBPACK FOOTER //
// ./src/helpers/NotificationPreferenceType.js